// extracted by mini-css-extract-plugin
export default {"address-list-container":"AddressBook_address-list-container__MK6ZH","filter-box":"AddressBook_filter-box__NHgot"};